import { render, staticRenderFns } from "./BudgetStep.vue?vue&type=template&id=68c2caa4&scoped=true&"
import script from "./BudgetStep.vue?vue&type=script&lang=ts&"
export * from "./BudgetStep.vue?vue&type=script&lang=ts&"
import style0 from "./BudgetStep.vue?vue&type=style&index=0&id=68c2caa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c2caa4",
  null
  
)

export default component.exports